// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inz-button {
    text-align: center;
}

.inz-save-button {
    width: auto;
    padding: 3% 6% 3% 6%;
    background-color: white;
    font-weight: bold;
    color: #03b4c6;
    font-family: sans-serif;
    border: 2px solid #03b4c6;
    border-radius: 1vh;
    margin: 3% auto 0;
    display: block;
    word-wrap: break-word;
}

.inz-save-button:hover {
    background-color: #03b4c6;
    color: white;
}

.inz-button-row{
    display: flex;
    text-align: justify;
}

.inz-delete-button {
    width: auto;
    padding: 3% 6% 3% 6%;
    background-color: rgb(255, 56, 56);
    font-weight: bold;
    color: white;
    font-family: sans-serif;
    border: 2px solid black;
    border-radius: 1vh;
    margin: 3% auto 0;
    display: block;
    margin-left: 10px;
}

.inz-delete-button:hover {
    background-color: red;
    color: white;
}

.inz-deletesp-button {
    width: auto;
    padding: 3% 6% 3% 6%;
    background-color: rgb(255, 56, 56);
    font-weight: bold;
    color: white;
    font-family: sans-serif;
    border: 2px solid black;
    border-radius: 1vh;
    margin: 3% auto 0;
    display: block;
    margin-left: 10px;
    height: auto;
}

.inz-deletesp-button:hover {
    background-color: red;
    color: white;
}

.inz-update-button {
    width: auto;
    padding: 3% 6% 3% 6%;
    background-color: rgb(56, 255, 142);
    font-weight: bold;
    color: white;
    font-family: sans-serif;
    border: 2px solid black;
    border-radius: 1vh;
    margin: 3% auto 0;
    display: block;
    height: auto;
}

.inz-update-button:hover {
    background-color: rgb(6, 236, 106);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/buttonstyle.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,kCAAkC;IAClC,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,kCAAkC;IAClC,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB","sourcesContent":[".inz-button {\n    text-align: center;\n}\n\n.inz-save-button {\n    width: auto;\n    padding: 3% 6% 3% 6%;\n    background-color: white;\n    font-weight: bold;\n    color: #03b4c6;\n    font-family: sans-serif;\n    border: 2px solid #03b4c6;\n    border-radius: 1vh;\n    margin: 3% auto 0;\n    display: block;\n    word-wrap: break-word;\n}\n\n.inz-save-button:hover {\n    background-color: #03b4c6;\n    color: white;\n}\n\n.inz-button-row{\n    display: flex;\n    text-align: justify;\n}\n\n.inz-delete-button {\n    width: auto;\n    padding: 3% 6% 3% 6%;\n    background-color: rgb(255, 56, 56);\n    font-weight: bold;\n    color: white;\n    font-family: sans-serif;\n    border: 2px solid black;\n    border-radius: 1vh;\n    margin: 3% auto 0;\n    display: block;\n    margin-left: 10px;\n}\n\n.inz-delete-button:hover {\n    background-color: red;\n    color: white;\n}\n\n.inz-deletesp-button {\n    width: auto;\n    padding: 3% 6% 3% 6%;\n    background-color: rgb(255, 56, 56);\n    font-weight: bold;\n    color: white;\n    font-family: sans-serif;\n    border: 2px solid black;\n    border-radius: 1vh;\n    margin: 3% auto 0;\n    display: block;\n    margin-left: 10px;\n    height: auto;\n}\n\n.inz-deletesp-button:hover {\n    background-color: red;\n    color: white;\n}\n\n.inz-update-button {\n    width: auto;\n    padding: 3% 6% 3% 6%;\n    background-color: rgb(56, 255, 142);\n    font-weight: bold;\n    color: white;\n    font-family: sans-serif;\n    border: 2px solid black;\n    border-radius: 1vh;\n    margin: 3% auto 0;\n    display: block;\n    height: auto;\n}\n\n.inz-update-button:hover {\n    background-color: rgb(6, 236, 106);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
